// Wave AW.3-React (2026-05-16) — JWT 인증 이미지 컴포넌트
// 백엔드 /buyer-app/auction/:id/photo/:idx 가 JWT 필수 → <img src> 가 Authorization 못 실음.
// 해결: fetch + URL.createObjectURL(blob) → <img src={blobUrl}>

import React, { useState, useEffect } from 'react';
import { fetchAuthImageBlobUrl } from './buyerApi';

function AuthImage(props) {
  var path = props.path;             // '/buyer-app/auction/123/photo/0'
  var style = props.style || {};
  var placeholder = props.placeholder || null;
  var alt = props.alt || '';

  var [url, setUrl] = useState('');
  var [error, setError] = useState(false);

  useEffect(function() {
    if (!path) { setUrl(''); return; }
    var cancelled = false;
    var blobUrl = '';
    setError(false);
    fetchAuthImageBlobUrl(path)
      .then(function(u) {
        if (cancelled) {
          URL.revokeObjectURL(u);
          return;
        }
        blobUrl = u;
        setUrl(u);
      })
      .catch(function() { if (!cancelled) setError(true); });
    return function() {
      cancelled = true;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [path]);

  if (error) {
    return placeholder || (
      <div style={Object.assign({ background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', fontSize: 12 }, style)}>
        이미지 없음
      </div>
    );
  }

  if (!url) {
    // 로딩 placeholder (skeleton)
    return (
      <div style={Object.assign({ background: '#e2e8f0', animation: 'pulse 1.5s ease-in-out infinite' }, style)} />
    );
  }

  return <img src={url} alt={alt} style={style} />;
}

export default AuthImage;
